import type { Location } from 'react-router-dom';

let latestLocation: Location | null = null;

export const setLatestLocation = (location: Location) => {
  latestLocation = location;
};

export const getLatestLocation = (): Location | null => {
  if (latestLocation) {
    return latestLocation;
  }

  if (typeof window !== 'undefined') {
    return {
      key: 'initial',
      state: null,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash
    };
  }

  return null;
};
